

import { getTree, TREE_DEEP_LEVEL } from '@shootsta/tree';
import _clone from 'lodash.clone';
import _last from 'lodash.last';


import { getDataTableCellRawValue } from './factories/dataTableCellValueFactory';
import { DATA_TABLE_ROW_NUMBER } from '../../../../common/constants/row/dataTableRow';



import { DATA_TABLE_ROW_HOVERABLE_TYPE } from '../../../../common/constants/row/dataTableRowHoverableType';




import { DATA_TABLE_ROW_INDICATOR } from '../../../../common/constants/row/dataTableRowIndicator';


export const getDataTableRowId = (
row,
columnFieldId) =>
getDataTableCellRawValue(row, columnFieldId);

const getDataTableTreeRowNodePath = (idField) => `data.${idField}`;

const getDataTableFlatRowNodeById = (
rowId, flatRowsNodes) =>
flatRowsNodes.find((flatRowNode) => flatRowNode.id === rowId);

const removeDataTableStatePropsFromFlatRowsNodes = (
flatRowsNodes) =>
flatRowsNodes.map(
  ({ isExpanded, ...restProps }) => restProps
);

const mapDataTableFlatToTreeRowsNodes = (
flatRowsNodes,
columnFieldId,
columnTreeParentFieldId) =>
getTree(
  removeDataTableStatePropsFromFlatRowsNodes(flatRowsNodes), {
    idFieldPath: getDataTableTreeRowNodePath(columnFieldId),
    parentIdFieldPath: getDataTableTreeRowNodePath(columnTreeParentFieldId)
  });

const getDataTableSpacerRowIdAttr = (rowId) => `${rowId}-spacer`;

const getDataTableLastTreeRowNodeInLevel = (
treeRowsNodes) =>
_last(treeRowsNodes);

const isDataTableTreeRowNodeParentRoot = (
treeRowNode) =>
treeRowNode.deepLevel === TREE_DEEP_LEVEL.ROOT + 1;


export const isDataTableTreeRowNodeLastInLevel = (
treeRowNode,
treeRowsNodes) =>
getDataTableLastTreeRowNodeInLevel(treeRowsNodes).id === treeRowNode.id;

export const hasDataTableTreeRowNodeChildren = (
treeRowNode) =>
!!treeRowNode.children;

export const isDataTableRowHoverable = (
getOnRowClick) =>
!!getOnRowClick;

export const getDataTableRowHoverableType = (
onRowClick) =>

onRowClick ? DATA_TABLE_ROW_HOVERABLE_TYPE.AVAILABLE : DATA_TABLE_ROW_HOVERABLE_TYPE.NOT_AVAILABLE;


export const toggleDataTableFlatRowNodeExpand = (
rowId,
flatRowsNodes) =>
{
  const newFlatRowsNodes = _clone(flatRowsNodes);
  const node = getDataTableFlatRowNodeById(rowId, newFlatRowsNodes);

  if (node) {
    node.isExpanded = !node.isExpanded;
  }

  return newFlatRowsNodes;
};

export const isDataTableTreeRowNodeRoot = (
treeRowNode) =>
treeRowNode.deepLevel === TREE_DEEP_LEVEL.ROOT;

export const hasDataTableRowSpacer = (
rowIndex,
treeRowNode) =>
rowIndex !== DATA_TABLE_ROW_NUMBER.FIRST && isDataTableTreeRowNodeRoot(treeRowNode);

export const isDataTableOddRow = (rowIndex) => !!((rowIndex + 1) % 2);

export const getDataTableTreeRowsNodes = (
flatRowsNodes,
columnFieldId,
columnTreeParentFieldId) =>
mapDataTableFlatToTreeRowsNodes(
  flatRowsNodes, columnFieldId, columnTreeParentFieldId
);

export const hasDataTableTreeRowsChildren = (
treeRowsNodes) =>
treeRowsNodes.some((treeRowNode) => hasDataTableTreeRowNodeChildren(treeRowNode));

export const isDataTableFlatRowExpanded = (
rowId,
flatRowsNodes) =>
(getDataTableFlatRowNodeById(rowId, flatRowsNodes) || {}).isExpanded;

export const isDataTableTreeRowNodeChildrenVisible = (
treeRowNode,
flatRowsNodes) =>
hasDataTableTreeRowNodeChildren(treeRowNode) && isDataTableFlatRowExpanded(
  treeRowNode.id, flatRowsNodes
);

export const getDataTableRowIdAttr = (
rowId,
isSpacer) =>
isSpacer ? getDataTableSpacerRowIdAttr(rowId) : rowId;

export const getDataTableRowIndicator = (
row,
rowIndex,
getRowIndicator,
isSpacer) =>

!isSpacer && getRowIndicator && getRowIndicator(row, rowIndex) ||
DATA_TABLE_ROW_INDICATOR.NONE;

export const isDataTableTreeRowNodeLastVisibleInBranch = (
treeRowNode,
treeRowsNodesOnLevel,
flatRowsNodes,
isParentLastTreeRowNodeInLevel) =>
{
  const isRowRoot = isDataTableTreeRowNodeRoot(treeRowNode);
  const isRowParentRoot = isDataTableTreeRowNodeParentRoot(treeRowNode);
  const isChildrenVisible = isDataTableTreeRowNodeChildrenVisible(treeRowNode, flatRowsNodes);
  const isLastInLevel = isDataTableTreeRowNodeLastInLevel(treeRowNode, treeRowsNodesOnLevel);

  if (isChildrenVisible) {
    return false;
  }

  if (isRowRoot) {
    return true;
  }

  if (isRowParentRoot && isLastInLevel) {
    return true;
  }

  if (isParentLastTreeRowNodeInLevel && isLastInLevel) {
    return true;
  }

  return false;
};

export const getDataTableFlatRowsNodes = (
rows,
columnFieldId) =>
rows.map((row) => ({
  id: getDataTableRowId(row, columnFieldId),
  data: row,
  isExpanded: false
}));